<template>
  <div
    class="dropdown-container tw-flex tw-items-center"
    :class="`${position} ${disabled ? 'disabled' : ''}`"
  >
    <button
      ref="el"
      :id="idCalc"
      class="dropdown-button"
      data-bs-toggle="dropdown"
      aria-expanded="false"
      :aria-label="ariaLabel ? ariaLabel : 'menu'"
      :data-test="testId"
    >
      <slot />
    </button>
    <ul
      ref="dropdownMenu"
      class="dropdown-menu tw-max-h-[calc(100vh_-_56px)] tw-overflow-y-auto !tw-text-text !nx-text-body2 !tw-bg-background-medium !tw-border-border !tw-min-w-fit !tw-p-2 !tw-space-y-2"
      :aria-labelledby="idCalc"
      role="menu"
    >
      <DropDownItem
        v-for="(item, i) in items"
        :item="item"
        :key="i"
        @clicked="hide"
        :testId="`${testId}${item.name.toLowerCase().replaceAll(' ', '-')}`"
      />
    </ul>
  </div>
</template>

<script>
import { computed, onMounted, ref } from "vue";
import { Dropdown } from "bootstrap";
import DropDownItem from "@/components/display/DropDownItem";
import uniqueId from "lodash-es/uniqueId";

export default {
  name: "DropDown",
  components: {
    DropDownItem,
  },
  props: {
    items: {
      type: Array,
    },
    appendToBody: {
      type: Boolean,
      default: false,
    },
    id: String,
    placement: {
      type: String,
      default: "bottom",
      validator: (val) => ["bottom", "left", "right", "top"].includes(val),
    },
    disabled: Boolean,
    ariaLabel: String,
    testId: {
      type: String,
      default: "",
    },
  },

  setup(props) {
    const POSITIONS = {
      bottom: "",
      left: "dropstart",
      right: "dropend",
      top: "dropup",
    };

    const el = ref(null);
    const dropdown = ref(null);
    const dropdownMenu = ref(null);
    const idCalc = computed(() => props.id || uniqueId("dropdown-"));
    const position = computed(() => POSITIONS[props.placement]);

    const hide = () => dropdown.value.hide();

    onMounted(() => {
      dropdown.value = new Dropdown(el.value);
      el.value.addEventListener("click", () => (dropdownMenu.value.scrollTop = 0));
    });

    return {
      el,
      dropdownMenu,
      hide,
      idCalc,
      position,
    };
  },
};
</script>

<style lang="scss" scoped>
.dropdown-container {
  &.disabled {
    @apply tw-opacity-50 tw-cursor-not-allowed;
    > * {
      @apply tw-pointer-events-none;
    }
  }
}
</style>
